<template>
  <div class="container">
    <div class="logo"></div>
    <div class="tips">抵制不良游戏，拒绝盗版游戏。 注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</div>
  </div>
  <!-- <div>
    <ranking></ranking>
  </div>-->
</template>

<script>
// import Ranking from '../components/popup/ranking'
export default {
  // components: {
  //   Ranking
  // }
  created() {
    setTimeout(() => {
      this.$router.replace('/index')
    }, 1000)
  },
  mounted() {
    document.body.style.background = '#ede4d1'
  },
  beforeDestroy() {
    // document.body.style.backgroundImage = 'url("https://image.co-study.com.cn/web/answer-game/main-bg.png")'
    document.body.style.background = '#bda477'
  }
}
</script>
<style lang="scss" scoped>
@function px2rem($px) {
  $rem: 375px;
  @return ($px/$rem) + rem;
}

.container {
  width: px2rem(667px);
  height: px2rem(375px);
  width: 100%;
  height: 100%;
  background: url('https://image.co-study.com.cn/web/answer-game/loading-bg.gif');
  background-size: 100% 100%;

  .logo {
    width: px2rem(350px);
    height: px2rem(223px);
    background: url('https://image.co-study.com.cn/web/answer-game/loading-text.gif') no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    top: px2rem(36px);
    left: 50%;
    transform: translateX(-50%);
  }

  .tips {
    width: 100%;
    font-size: px2rem(10px);
    color: #BEA577;
    text-align: center;
    position: absolute;
    bottom: px2rem(11px);
  }
}
</style>